module.exports = __webpack_public_path__ + "assets/img/img-5.cb47f729.png";